import { Component, OnInit } from '@angular/core';
import { NewsService } from '../news/news.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-news-links',
  templateUrl: './news-links.component.html',
  styleUrls: ['./news-links.component.scss']
})
export class NewsLinksComponent implements OnInit {
  public news;
  selectedActu;
  activeLink: string;

  constructor(
    private router: Router,
    private location: Location,
    private newsService: NewsService,

  ) {
    router.events.subscribe((url:any) => this.activeLink = router.url);
    console.log(this.activeLink);
  }

  ngOnInit() {
    this.getNews();
  }

  getNews(){
    this.newsService.getNews().subscribe(
      data => { this.news = data },
      err => console.error(err)
      // () => console.log(this.news)
    );
  }

  onSelect(actu): void{
    this.selectedActu = actu;
  }

}



// WEBPACK FOOTER //
// ./src/app/news-links/news-links.component.ts